export const COUPON_MODE = {
  view: 'view',
  edit: 'edit',
  add: 'add'
};

export const discountTypeOptions = [
  { id: 1, label: 'Percentage', value: 'Percentage' },
  { id: 2, label: 'Fixed Amount', value: 'Fixed Amount' }
];

export const expiresInOptions = [
  { id: 1, label: 'Custom time', value: 'Custom Time' },
  { id: 2, label: 'Unlimited', value: 'Unlimited' }
];

export const pricingPlanOptions = [
  { id: 1, label: 'Basic', value: 'Basic' },
  { id: 2, label: 'Standard', value: 'Standard' },
  { id: 3, label: 'Premium', value: 'Premium' }
];

export const mockProductOptions = [];

export const emptyForm = {
  code: '',
  name: '',
  type: '',
  currency: '',
  value: '',
  expiresIn: '',
  startDate: '',
  endDate: '',
  status: '',
  orderId: '',
  products: [
    { productId: '', productName: '', plans: [{ planId: '', planName: '' }] }
  ]
};
